import { cssUtil } from "../../utils/cssUtil";
import { getBaseStyles } from "../commonStyles";


export async function renderCheckboxFieldWidget(context, widget, parent, override = null) {

    const device = widget?.properties?.desktop;
    if (!device) return;

    // Root container
    const container = context.document.createElement("div");
    container.classList.add("widget", "form_field_widget");
    const breakpoint = context.currentBreakpoint;

    const styles = {
        ...getBaseStyles(widget, breakpoint)
    };

    applyFieldStyles(styles, device);
    container.setAttribute("style", cssUtil.toStyleString(styles));
    container.setAttribute("data-widgetId", widget.uid);
    container.setAttribute("data-widgetType", widget.type);
    container.setAttribute("data-widgetParent", widget.parent);
    parent.appendChild(container);

    // Fetch list field (same as Java)
    let listField = null;
    try {
        listField = await context.customFieldService.getCustomField(
            String(widget.content)
        );
    } catch (e) {
        console.error(e);
        return;
    }

    // Label
    const label = renderLabel(context, device);
    if (label) container.appendChild(label);

    // Checkbox container
    const checkboxContainer = context.document.createElement("div");
    const checkboxContainerStyles = {};
    applyCheckboxContainerStyles(checkboxContainerStyles, device);
    checkboxContainer.setAttribute(
        "style",
        cssUtil.toStyleString(checkboxContainerStyles)
    );

    // Options
    listField.options.forEach(option => {
        const fieldContainer = context.document.createElement("span");

        const containerStyles = {};
        applyFieldContainerStyles(containerStyles, device);
        fieldContainer.setAttribute(
            "style",
            cssUtil.toStyleString(containerStyles)
        );

        const checkbox = renderCheckbox(context, device);
        fieldContainer.appendChild(checkbox);

        const value = renderFieldValue(context, device, option.value);
        fieldContainer.appendChild(value);

        checkboxContainer.appendChild(fieldContainer);
    });

    container.appendChild(checkboxContainer);
    return container;
}

function renderLabel(context, device) {
    if (!device.label) return null;

    const el = context.document.createElement("div");
    el.innerHTML = device.label;

    const styles = {};
    applyLabelStyles(styles, device);
    el.setAttribute("style", cssUtil.toStyleString(styles));

    return el;
}

function renderCheckbox(context, device) {
    const boxStyle = device.multiSelect
        ? "boolean-checkbox"
        : "boolean-circle";

    const el = context.document.createElement("div");
    el.classList.add(boxStyle);

    const styles = {};
    applyInputStyles(styles, device);
    el.setAttribute("style", cssUtil.toStyleString(styles));

    return el;
}

function renderFieldValue(context, device, label) {
    const el = context.document.createElement("span");
    el.innerHTML = label;

    const styles = {};
    applyCheckboxFieldValueStyles(styles, device);
    el.setAttribute("style", cssUtil.toStyleString(styles));

    return el;
}

function applyFieldStyles(styles, device) {
    const fieldSpacing = device.styles?.layout?.fieldSpacing;

    if (fieldSpacing) {
        styles["padding-bottom"] = `${fieldSpacing}px`;
    }

    const regular = device.styles?.regular;
    if (!regular) return;

    styles["vertical-align"] = "bottom";
    applyFontStyles(styles, regular.label);
}

function applyLabelStyles(styles, device) {
    const layout = device.styles?.layout;
    const regular = device.styles?.regular;
    if (!layout || !regular) return;

    const { alignment, fieldSpacing, labelPadding } = layout;

    if (fieldSpacing) {
        styles["padding-bottom"] = `${fieldSpacing}px`;
    }

    if (labelPadding) {
        if (alignment === "left") styles["padding-left"] = `${labelPadding}px`;
        if (alignment === "right") styles["padding-right"] = `${labelPadding}px`;
    }

    const colorProp = regular.label?.color;
    if (colorProp) {
        styles.color =
            colorProp.type === "gradient"
                ? cssUtil.getCssGradient(colorProp)
                : cssUtil.getCssColor(colorProp);
    }

    styles["vertical-align"] = "bottom";
    applyFontStyles(styles, regular.label);
}

function applyCheckboxFieldValueStyles(styles, device) {
    const regular = device.styles?.regular;
    if (!regular) return;

    styles["padding-left"] = "8px";
    styles["vertical-align"] = "bottom";

    applyFontStyles(styles, regular.input);
}

function applyFieldContainerStyles(styles, device) {
    const spaceBetweenItems = device.styles?.layout?.spaceBetweenItems;

    let paddingProp = "padding-bottom";

    if (device.multiColumn) {
        styles.display = "inline-block";
        paddingProp = "padding-right";
    } else {
        styles.display = "block";
    }

    styles[paddingProp] = `${spaceBetweenItems || 10}px`;
    styles.margin = "0px 0px 2px";
}

function applyCheckboxContainerStyles(styles, device) {
    const inputPadding = device.styles?.layout?.inputPadding;

    styles.display = device.multiColumn ? "inline-block" : "block";

    if (inputPadding) {
        styles["margin-left"] = `${inputPadding}px`;
    }
}

function applyInputStyles(styles, device) {
    const regular = device.styles?.regular;
    if (!regular) return;

    const bg = regular.input?.background;

    if (!bg) {
        styles.background = "#ffffff";
        return;
    }

    styles.background =
        bg.type === "gradient"
            ? cssUtil.getCssGradient(bg)
            : cssUtil.getCssColor(bg);
}

function applyFontStyles(styles, fontStyle) {
    if (!fontStyle?.font) return;

    const font = fontStyle.font;

    if (font.fontFamily) styles["font-family"] = font.fontFamily;
    if (font.fontSize) styles["font-size"] = `${font.fontSize}px`;
    if (font.lineSpacing) styles["line-height"] = `${font.lineSpacing}em`;
    if (font.letterSpacing) styles["letter-spacing"] = `${font.letterSpacing}em`;
}
